import { BookService } from '../../services/BookService';
import { AppThunk } from '../store';
import { libraryActions } from './librarySlice';

export const bookDeleteAction = (id: string): AppThunk => async dispatch => {
  await BookService.removeBook(id);
  dispatch(libraryActions.removeBook(id));
};
